import type { INews } from '@entities/publication';
import type { FetchLoaderType } from '@shared/lib/routing';
import type { ISeoPage } from '@widgets/seoPage';
import type { ICategoryFilter } from '@features/category-filter';
import { NEWS_LIMIT } from '../model/constants';

type Params = {
  city: string;
};

type Query = {
  tag: string;
  page: string;
};

export const newsPageLoader = async (
  fetch: FetchLoaderType,
  { params, query, lang }: { params: Params; query: Query; lang: string },
) => {
  const { city } = params;
  const { tag, page } = query || {};
  const requestLimit = page ? (Number(page) + 1) * NEWS_LIMIT : NEWS_LIMIT;
  const [seoPageResponse, newsPageResponse, categoriesPageResponse] =
    await Promise.all([
      fetch<ISeoPage>({
        url: '/seo/page',
        params: { url: `/news`, city, lang },
      }),
      fetch<{ news: INews[] }>({
        url: '/news',
        params: { city, lang, tag, limit: requestLimit },
      }),
      fetch<{ categories: ICategoryFilter[] }>({
        url: '/news/get_categories',
        params: { city, lang },
      }),
    ]);
  return {
    seoPageData: seoPageResponse.data,
    newsPageData: newsPageResponse.data,
    categoriesPageData: categoriesPageResponse.data,
  };
};
